import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getReferralDataBanner(authorization, filter) {
  const url = `${API_URL}/admin/referral/click-banner`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getReferralDataShare(authorization, filter) {
  const url = `${API_URL}/admin/referral/click-share`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getReferralDataMember(authorization, filter) {
  const url = `${API_URL}/admin/referral/member`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/referraldata.js